export default __webpack_public_path__ + "static/media/Maduro.b1be6bc8.png";